import AdminAddPasein from "../../components/AdminPurchaseInvoice/AdminPurchaseInvoiceAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
